import * as React from 'react'
import { useCallback } from 'react'

import { BillTo } from '@user/store/entityLocations'
import { TidalBillToRadioCard } from '../BillToRadioCard/TidalBillToRadioCard'

type Props = {
  locations?: BillTo[]
  onChange?: (locationId: string, locationCode?: string) => void
  billToId?: string
}

export function TidalBillToRadioList(props: Props) {
  const { locations, onChange, billToId } = props

  const handleClick = useCallback(
    (locationId: string) => {
      if (onChange) {
        onChange(
          locationId,
          locations?.find((x) => x.id === locationId)?.number,
        )
      }
    },
    [onChange, locations],
  )

  return locations ? (
    <>
      {locations.map((item, index) => (
        <TidalBillToRadioCard
          checked={item.id === billToId}
          key={index}
          location={item}
          onClick={handleClick}
        />
      ))}
    </>
  ) : null
}
